import React from "react";
import "../../index.css";
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import nativeamericans from '../../Assets/Img/nativeamericans.jpg'

const Chap5 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
        <Link to="/Chap4">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap6">Next</Link>
      </div>

      <h1 className="chapterHeading">
        Chapter 5: Lamanites and Ephraimites to Build Zion
      </h1>

      <img src={nativeamericans} className='image' alt='Mormons baptizing Native Americans' />

    <div className="wrapper">


      <div className="paragraph">
        <p>
          The Mormons were not to build the holy city alone. In the Book of
          Mormon, the resurrected Christ preaches that the Lamanites have the
          primary responsibility to build the holy city of Zion on the American
          continent. After all, America is the land of inheritance for the
          Lamanites as a branch of the House of Israel. Christ preached, “… the
          Father hath commanded me that I should give unto you (Lamanites) this
          land, for your inheritance.”
          <btn id="clickable1" className="footnote">1  </btn>
          <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>3 Nephi 20:14.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Christ prophesied that the future Zion in Jackson County would be
          built by the Lamanites, “And behold, this people (future Lamanites)
          will I establish in this land (America) … and it shall be a New
          Jerusalem. And the powers of heaven shall be in the midst of this
          people; yea, even I will be in the midst of you.” 
          <btn id="clickable2" className="footnote">2  </btn>
          <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>3 Nephi 20:21-22.</Tooltip>
          
          In 3 Nephi, Christ
          says to the future Gentiles who convert to Mormonism in the 1830s and
          1840s, that they will help the Lamanites build Zion. “And they shall
          assist my people, the remnant of Jacob (Lamanites) … that they may
          build a city, which shall be called the New Jerusalem. And then shall
          they (Mormon converts) assist my people that they may be gathered in
          (adopted into the House of Israel) … in unto the New Jerusalem.”
          <btn id="clickable3" className="footnote">3  </btn>
          <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>3 Nephi 21:23-25.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Early Mormon George Davis wrote, “[Joseph stated] that God had
          revealed to him that the Indians and Latter-Day Saints, under Joseph
          as their King and Ruler, were to conquer the Gentiles, and that their
          subjection to this authority was to be obtained by the sword!” 
          <btn id="clickable4" className="footnote">4  </btn>
          <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>Geo. T. M. Davis, An Authentic Account of the Massacre of Joseph Smith, The Mormon Prophet and Hyrum Smith, 1844, 7-8.</Tooltip>
          
          Early
          Mormon Lyman Wight stated, “Instruction was given me by brother Joseph
          with great zeal; setting forth the necessity for such a mission, for
          the good of the cause of bringing the Lamanites to the knowledge of
          the truth, paving the way for the redemption of Zion and building the
          Temple in Jackson County.” 
          <btn id="clickable5" className="footnote">5  </btn>
          <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>Letter of Lyman Wight on 29 November 1844, included in his Address. Lyman Wight, An Address by Way of an Abridged Account and Journal of My Life from February 1844 up to April 1848, with An Appeal to the Latter-Day Saints ([Austin, TX], 1848), 5-6..</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Once the remnant of Jacob (Lamanites) and the converted Gentiles
          (Mormons) build Zion, the New Jerusalem, “Then shall the remnant
          (scattered descendants of the House of Israel) ... be gathered in from
          the east and from the west, and from the south and from the north; and
          they shall be brought to the knowledge of the Lord their God.” 
          <btn id="clickable6" className="footnote">6  </btn>
          <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>3 Nephi 20:12-13.</Tooltip>
          
          This is
          the great gathering of the 12 Tribes of Israel, the driving force of
          Mormonism.
        </p>
      </div>

      <h2 className="headlinePadding" >Mormon Converts Descend from Ephraim</h2>

      <div className="paragraph">
        <p>
          A quick history lesson. In 721 BCE, the Assyrians took 10 of the 12
          Tribes of Israel captive. These 10 tribes never returned to the land
          of Judah. Besides one group that remained intact (Lost Ten Tribes),
          over the centuries the descendants of these 10 tribes mixed with
          Gentiles in other countries. Brigham Young stated, “… the ten tribes,
          who wandered into the north, will be gathered home, and the blood of
          Ephraim … which is to be found in every kingdom and nation under
          heaven, will be gathered from among the Gentiles.”
          <btn id="clickable7" className="footnote">7  </btn>
          <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>Brigham Young, Discourses of Brigham Young, p. 121–22.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          According to Mormonism, the most righteous descendants of the 10
          tribes come from the Tribe of Ephraim. Joseph Smith taught that people
          of the Ephraimite bloodline were early converts to Mormonism. Brigham
          Young stated, “Joseph Smith was a pure Ephraimite, and the Book of
          Mormon was revealed to him, and while he lived, he made it his
          business to search for those who believed the Gospel.” 
          <btn id="clickable8" className="footnote">8  </btn>
          <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>Brigham Young, Journal of Discourses, April 8, 1855, vol. 2, p. 269.</Tooltip>
          
          Being from the
          House of Israel, when they heard the message of Joseph’s restored
          gospel, it was familiar to them. Sixth Mormon prophet Joseph F. Smith
          said, “… through obedience, we often catch a spark from the awakened
          memories of the immortal soul, which lights up our whole being as with
          the glory of our former home.”
          <btn id="clickable9" className="footnote">9  </btn>
          <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>Joseph F. Smith, Gospel Doctrine, 213-14.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Descendants of the Tribe of Ephraim also have a leadership role to
          play in the latter days. Tenth Mormon prophet Joseph Fielding Smith
          stated, “It is essential in this dispensation that Ephraim stand in
          his place at the head, exercising the birthright in Israel ... Ephraim
          must be gathered first to prepare the way, through the gospel and the
          priesthood, for the rest of the tribes of Israel when the time comes
          for them to be gathered to Zion. The great majority of those who have
          come into the Church are Ephraimites.”
          <btn id="clickable10" className="footnote">10  </btn>
          <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>Joseph Fielding Smith, Doctrines of Salvation, vol. 3, p. 252–53.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          In Joseph’s vision of establishing Zion, these descendants of the
          Tribe of Ephraim, along with the descendants of the Lamanites will
          build Zion, the New Jerusalem in Jackson County.
        </p>
      </div>

      <h2 className="headlinePadding" >Zion to Be Built as a Refuge and Center of Spiritual Power</h2>

      <div className="paragraph">
        <p>
          According to biblical prophecy, catastrophic events are to happen
          throughout the world in the end times. Joseph prophesied about the
          last days, “And in that day shall be heard of wars and rumors of wars,
          and the whole earth shall be in commotion, and men’s hearts shall fail
          them.”
          <btn id="clickable10" className="footnote">10  </btn>
          <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>D&C 45:2.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          According to revelations given to Joseph Smith, it is God’s design
          that Zion be established as a place of refuge for humanity. It will be
          the only place to escape the wars, famine, wickedness, scourges, and
          societal upheaval. But additionally, Zion will be a place of spiritual
          transformation for the righteous where they may prepare to meet Christ
          at his coming. Mormon apostle Orson Pratt stated, “The gates of Zion
          shall be open, and the Gentile shall flood in … the Gentiles will, in
          that day, come to us as a flowing stream, and we shall have to set our
          gates open continually, they will come as clouds and as doves in large
          flocks. Do you suppose that the Gentiles are going to be ignorant of
          what is taking place?”
          <btn id="clickable11" className="footnote">11  </btn>
          <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>Orson Pratt, Journal of Discourses, May 20, 1855, vol. 3, p. 17.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          In Zion, people will partake of Christ’s divine nature. They will
          transform themselves into Christlike beings with Christlike powers. “…
          he that receiveth light, and continueth in God, receiveth more light;
          and that light groweth brighter and brighter until the perfect day.”
          <btn id="clickable12" className="footnote">12  </btn>
          <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>D&C 50:24.</Tooltip>

          Nephi stated that Zion’s inhabitants will be endowed “with the power
          of God in great glory.” With this power and glory “the sons and
          daughters of the faithful will prophesy and see visions and the old
          men dream dreams.” 
          <btn id="clickable13" className="footnote">13  </btn>
          <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>Joel 2:28-29. According to Joseph, the Angel Moroni quoted these scriptures describing the spiritual gifts to be found in Zion.</Tooltip>
          
          Both the city and its inhabitants will shine with
          light. They will be filled with tangible glory so that they
          personally, and the city they are building, will shine forth as a
          beacon to the world. Orson Pratt stated, “… her dwellings shall be
          encircled with glory; her light shall be as the sun, and her beauty as
          the morning; her tabernacles shall be as the dwelling places, kings
          shall arise and worship.”
          <btn id="clickable14" className="footnote">14  </btn>
          <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>“Divine Authenticity Of The Book Of Mormon: Prophetic Evidence In Favor Of The Book Of Mormon,” in A Series Of Pamphlets By Orson Pratt (Liverpool, England, 1851), p. 91.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          The Book of Mormon gives an example of the glory-filled experiences
          that will be prevalent in Zion. During Christ’s appearance to the
          Nephites, he baptized them with fire and with the Holy Ghost. “And as
          they looked to behold, they cast their eyes toward heaven, and they
          saw the heavens open, and they saw angels descending out of heaven as
          it were in the midst of fire, and they came down and encircled those
          little ones about, and they were encircled about with fire; and the
          angels did minister unto them.”
        </p>
      </div>

      <h2 className="headlinePadding" >As the End Nears, All Not Well Outside Zion</h2>

      <div className="paragraph">
        <p>
          As Zion is purified and sanctified, the world outside Zion will
          increase in debauchery and depravity. The wicked will refuse to repent
          and seek refuge in the brilliant Zion bathed in God’s light and glory.
          Then will come the time for the rebellious and wicked to be destroyed
          to cleanse earth. By vision, Joseph was shown these “desolating
          scourges.” Early Mormon Wandle Mace stated, “I have listened to his
          (Joseph) recital of the vision given him of the terrible calamities
          which would sweep over the earth as with a besom of destruction. The
          vision was so horrifying that he prayed the Lord to take it away; and
          the Lord gave him the vision a little at a time so he could bear it.”
        <btn id="clickable15" className="footnote">15  </btn>
        <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>Journal of Wandle Mace, 1809-1890, Brigham Young University Library, MSS 921, p. 61.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          In January 1833, Joseph prophesied, “… by the authority of Jesus
          Christ, that not many years shall pass away before the United States
          shall present such a scene of bloodshed as has not a parallel in the
          history of our nation; pestilence, hail, famine, and earthquake will
          sweep the wicked of this generation from off the face of the land, to
          open and prepare the way for the return of the lost tribes of Israel
          from the north country.” Joseph continued, “The people of the Lord,
          those who have complied with the requirements of the new covenant,
          have already commenced gathering together to Zion, which is in the
          state of Missouri; therefore, I declare unto you the warning which the
          Lord has commanded to declare unto this generation... therefore, ‘Fear
          God, and give glory to Him, for the hour of His judgment is come.’
          Repent ye, repent ye, and embrace the everlasting covenant, and flee
          to Zion.”
          <btn id="clickable16" className="footnote">16  </btn>
          <Tooltip anchorSelect="#clickable16" className="footnote-size" clickable>History of the Church 1:315.</Tooltip>

        </p>
      </div>

      <div className="paragraph">
        <p>
          In the midst of these natural disasters, famines, and wars, a small
          beam of light will appear in the sky. The wicked that remain will
          assume it is a comet. As he approaches, the light will grow brighter
          and brighter. The brilliance and power of Christ’s glory will defy
          human power to describe. Joseph revealed, “So great shall be the glory
          of his presence that the sun shall hide his face in shame and the moon
          shall withhold its light, and the stars shall be hurled from their
          places.” 
          <btn id="clickable17" className="footnote">17  </btn>
          <Tooltip anchorSelect="#clickable17" className="footnote-size" clickable>D&C 133:49.</Tooltip>
          
          But more on that later.
        </p>
      </div>

      <h2 className="headlinePadding" >Coming Up …</h2>

      <div className="paragraph">
        <p>
          This concludes Part I. In part II, Joseph’s expansive vision of
          latter-day events leading to the Second Coming will be presented. This
          includes God’s command to build the holy city of Zion, the New
          Jerusalem with a complex of 24 temples at the center. Fighting the
          great and abominable church as Zion is built. Zion being filled with
          God’s glory, which will illuminate the residents and the physical
          structures of the city. Receiving the Lost 10 Tribes from the north.
          Sending out the 144,000 to gather the elect from the four corners of
          the earth. And more!
        </p>
      </div>

      <div className="paragraph">
        <p>
          Part II also presents Joseph’s prophetic insights on how the Second
          Coming will be brought on by the seven angels from the Book of
          Revelation. They will pour out of terrible judgments upon the wicked
          to cleanse the earth. Then, Michael, the seventh angel of the harvest,
          will sound his trump and pour forth his vial, stating “It is done.” At
          that point, the powers of heaven will then be shaken, and “the curtain
          of heaven” will be unfolded as “a scroll is unfolded after it is
          rolled up.” Christ will appear in glory.
        </p>
      </div>

      <div className="paragraph">
        <p>
          In part III, we will examine Joseph’s concepts of the family of God.
        </p>
      </div>

      <div className="paragraph">
        <p>
          In part IV, we will examine the failed implementation of building the
          Kingdom of God.
        </p>
      </div>

      <div className="paragraph">
        <p>
          In part VI, given Joseph’s failed prophetic vision of the last days,
          we will examine how, at the beginning of the 20th century, the Mormon
          church essentially created a new religion. They jettisoned many of
          Joseph’s revelations and teachings he deemed essential for exaltation
          and created a new narrative.
        </p>
      </div>

      <div className="paragraph">
        <p>
          We see the Mormon church doing the same thing now, disregarding many
          of the teachings of the 20th century. They are now “evangelizing” the
          church to save it from dwindling attendance as they attempt to put
          Christ front and center. It will only be a matter of time before
          statues of Moroni atop temples are replaced with crosses, and the
          apostles will wear crosses when they speak in general conference – the
          cross, a once forbidden emblem in Mormonism. Only Jesus can save them
          now.
        </p>
      </div>

      </div>

      <div className="chapterFooter">
        <Link to="/Chap4">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap6">Next</Link>
      </div>
      
    </div>
  );
};

export default Chap5;
